import Router, { SingletonRouter } from "next/router";

import { ROUTES } from "shared/constants";
import type { SearchQuery } from "shared/data/reducers/types/storage";
import FlightCombination from "shared/types/flightCombination";

import { policiesPassed } from "@components/Flights/TravelPolicies";

type RouterWithSearchQuery = SingletonRouter & { query: SearchQuery };

const brandedFaresPickFlight = (
  url: RouterWithSearchQuery,
  selectedCombination: FlightCombination,
  refs: string[],
  policyResolve?: any,
  brandCheckedBaggageService?: string,
  flightSource?: string,
  brandedFares?: boolean
) => {
  const baggageLimit = selectedCombination.PricingDetail.BaggageLimit;

  let query: any = {
    refs,
    ...url.query,
    detailsAvailable: baggageLimit.DetailsAvailable,
    baggageLimitQuantity: baggageLimit?.Quantity_2 ?? baggageLimit.Quantity,
    baggageLimitWeight: baggageLimit?.Weight_2 ?? baggageLimit.Weight,
    baggageIncluded: brandCheckedBaggageService ?? null,
    flightSource: flightSource ?? null,
    brandsDetailsAvailable: true,
  };
  query = policyResolve?.Id
    ? { ...query, policyResolvedId: policyResolve.Id }
    : query;

  query =
    policyResolve &&
    policyResolve?.length !== 0 &&
    !policiesPassed(policyResolve?.Value || policyResolve)
      ? { ...query, policyFailed: true }
      : query;

  if (brandedFares) {
    const refsParam = refs
      .map((ref) => `refs=${encodeURIComponent(ref)}`)
      .join("&");

    const baseUrl = ROUTES.RESULT;
    const originalQuery = query;
    delete originalQuery.refs;

    const queryParams = new URLSearchParams();
    Object.entries(originalQuery).forEach(([key, value]) => {
      (Array.isArray(value) ? value : [value]).forEach((item) =>
        queryParams.append(key, String(item))
      );
    });
    const finalUrl = `${baseUrl}?${refsParam}&${queryParams.toString()}`;

    window.location.href = finalUrl;
    return;
  }

  return Router.push({
    pathname: ROUTES.RESULT,
    query,
  });
};

export default brandedFaresPickFlight;
